export default "__VITE_ASSET__ed0ef953__"